import Page from "layouts/Page";
import { Divider, Heading, Box } from "@chakra-ui/react";

export default function () {
  return (
    <Page>
      <Box bg="white" p={6} my={6} borderRadius="xl" boxShadow={"xl"}>
        <article>
          <Heading>CONDITIONS GENERALES DE VENTE</Heading>
          <Divider />
          <p>En vigueur au 01/04/2022</p>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 1 - CHAMP D'APPLICATION</Heading>
            <p>
              Les présentes Conditions Générales de Vente (dites « CGV »)
              s'appliquent, sans restriction ni réserve à tout achat des
              services de suivants :
              <br />
              <br />
              Prises de vue d'un client à bord d'un avion au décollage ou à
              l'atterrissage, exécutées par un photographe professionnel, au sol
              tels que proposés par le Prestataire aux clients non
              professionnels (« Les Clients ou le Client ») sur le site
              www.tete-en-lair.fr.
              <br />
              <br />
              Les caractéristiques principales des Services sont présentées sur
              le site internet www.tete-en-lair.fr.
              <br />
              <br />
              Le Client est tenu d'en prendre connaissance avant toute passation
              de commande. Le choix et l'achat d'un Service est de la seule
              responsabilité du Client.
              <br />
              <br />
              Ces CGV sont accessibles à tout moment sur le site
              www.tete-en-lair.fr et prévaudront sur toute autre document.
              <br />
              <br />
              Le Client déclare avoir pris connaissance des présentes CGV et les
              avoir acceptées en cochant la case prévue à cet effet avant la
              mise en œuvre de la procédure de commande en ligne du site
              www.tete-en-lair.fr.
              <br />
              <br />
              Sauf preuve contraire, les données enregistrées dans le système
              informatique du Prestataire constituent la preuve de l’ensemble
              des transactions conclues avec le Client.
              <br />
              <br />
              Les coordonnées du Prestataire sont les suivantes :
            </p>
            <p>
              Barbe Benjamin
              <br />
              Paris
              <br />
              Société Never Stop
              <br />
              Siret N° : 83984206900016
              <br />
              Mail : contact@tete-en-lair.fr
              <br />
              Telephone : +33610487976
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 2 - PRIX</Heading>
            <p>
              Les Services sont fournis aux tarifs en vigueur figurant sur le
              site www.tete-en-lair.fr lors de l'enregistrement de la commande
              par le Prestataire.
              <br />
              <br />
              Les prix sont exprimés en Euros TTC.
              <br />
              <br />
              Les tarifs sont fermes et non révisables pendant leur période de
              validité mais le Prestataire se réserve le droit, hors période de
              validité, d'en modifier les prix à tout moment.
              <br />
              <br />
              Le paiement demandé au Client correspond au montant total de
              l'achat, y compris ces frais. Une facture est établie par le
              Prestataire et remise au Client lors de la fourniture des Services
              commandés.
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 3 - COMMANDES</Heading>
            <p>
              Il appartient au Client de sélectionner sur le site
              www.tete-en-lair.fr les Services qu'il désire commander, selon les
              modalités suivantes :
              <br />
              <br />
              Dès que le client reçoit le lien pour pouvoir télécharger la
              photographie, il est dirigé vers la page du paiement et reçoit
              sa photographie présente sur un serveur sécurisé. Il
              peut télécharger la photographie lorsqu'il sera arrivé sur cette
              page.
              <br />
              <br />
              La vente ne sera considérée comme valide qu'après paiement
              intégral du prix. Il appartient au Client de vérifier l'exactitude
              de la commande et de signaler immédiatement toute erreur. Toute
              commande passée sur le site www.tete-en-lair.fr constitue la
              formation d'un contrat conclu à distance entre le Client et le
              Prestataire. Toute commande passé sur le site www.tete-en-lair.fr
              génère un contrat de licence de droits d’auteur entre le Client et
              le Photographe. Ce contrat permet au client de pouvoir faire libre
              usage de l’Œuvre, sous certaines conditions définies dans le
              contrat, mais protège également le photographe concernant l’œuvre
              créée à l’occasion de la demande formulée par le Client sur le
              site www.tete-en-lair.fr. Cela lui permet de conserver ses droits
              d’auteur et de pouvoir faire libre usage de son Œuvre comme bon
              lui semble. <br />
              <br />
              Le Prestataire se réserve le droit d'annuler ou de refuser toute
              commande d'un Client avec lequel il existerait un litige relatif
              au paiement d'une commande antérieure.
            </p>
          </section>
          <section>
            <Heading fontSize={"lg"}>Système communautaire</Heading>
            <p>
              Le Client pourra suivre l'évolution de sa commande par mail. Il
              sera informé si sa commande peut être honorée ou non. En fonction
              de différents aléas (climatiques, matériels ou personnels), la
              commande du Client n’est pas garantie par le prestataire. Un
              photographe peut très bien accepter une commande sans pour autant
              l’honorer en fonction de différents évènements indépendants ou non
              de sa volonté. Une commande peut ne pas être honorée si aucun
              photographe n’est disponible, en fonction des informations
              fournies par le Client (Date du vol, horaires, météo).
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>
              ARTICLE 4 - CONDITIONS DE PAIEMENT
            </Heading>
            <p>
              Le prix est payé par voie de paiement sécurisé, selon les
              modalités suivantes :
            </p>
            <ul>
              <li>paiement par carte bancaire</li>
              <li>
                paiement par virement bancaire sur le compte bancaire du Vendeur
                (dont les coordonnées sont communiquées au Client lors de la
                passation de la commande)
              </li>
            </ul>
            <p>
              Le prix est payable comptant, en totalité au jour de la fourniture
              des Services, intervenant selon les conditions définies à
              l'article • Fourniture des Prestations • et comme indiqué sur la
              facture remise au Client.
              <br />
              <br />
              Les données de paiement sont échangées en mode crypté grâce au
              protocole défini par le prestataire de paiement agréé intervenant
              pour les transactions bancaires réalisées sur le site
              www.tete-en-lair.fr.
              <br />
              <br />
              Les paiements effectués par le Client ne seront considérés comme
              définitifs qu'après encaissement effectif des sommes dues, par le
              Prestataire. <br />
              <br />
              Le Prestataire ne sera pas tenu de procéder à la fourniture des
              Services commandés par le Client si celui-ci ne lui en paye pas le
              prix en totalité dans les conditions ci-dessus indiquées.
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>
              ARTICLE 5 - FOURNITURE DES PRESTATIONS
            </Heading>
            <p>
              Les Services commandés par le Client seront fournis selon les
              modalités suivantes :
              <br />
              <br />
              La prestation est assurée dès lors que le photographe a réussi à
              prendre en photo l'avion qui effectue le vol selon les
              informations précédemment fournies par le client au moment de la
              création de la commande.
              <br />
              <br />
              Lesdits Services seront fournis dans un délai maximum dès lors que
              le vol a été pris en photo par le photographe, à compter de la
              validation définitive de la commande du Client, dans les
              conditions prévues aux présentes CGV à l'adresse indiquée par le
              Client lors de sa commande sur le site www.tete-en-lair.fr.
              <br />
              <br />
              Le Prestataire s'engage à faire ses meilleurs efforts pour fournir
              les Services commandés par le Client dans le cadre d'une
              obligation de moyen et dans les délais ci-dessus précisés.
              <br />
              <br />
              Si les Services commandés n'ont pas été honorés dans un délai de
              30 jours, se référer à l’article 3 Commandes, rubrique Système
              Communautaire. Toutefois, le Client sera informé du statut de sa
              commande par mail. Si sa commande n’a pu être honorée, elle est
              alors annulée et le Client en est notifié par mail.
              <br />
              <br />
              Pour toute autre cause que la force majeure ou le fait du Client,
              la vente des Services pourra être résolue à la demande écrite du
              Client dans les conditions prévues aux articles L 2 16-2, L 2 16-3
              et L241-4 du Code de la consommation.
              <br />
              <br />
              Les sommes versées par le Client lui seront alors restituées au
              plus tard dans les quatorze jours qui suivent la date de
              dénonciation du contrat, à l'exclusion de toute indemnisation ou
              retenue. En cas de demande particulière du Client concernant les
              conditions de fourniture des Services, dûment acceptées par écrit
              par le Prestataire, les coûts y étant liés feront l'objet d'une
              facturation spécifique complémentaire ultérieure.
              <br />
              <br />
              A défaut de réserves ou réclamations expressément émises par le
              Client lors de la réception des Services, ceux-ci seront réputés
              conformes à la commande, en Quantité et Qualité.
              <br />
              <br />
              Le Client disposera d'un délai de 30 jours à compter de la
              fourniture des Services pour émettre des réclamations par mail à
              contact@tete-en-lair.fr, avec tous les justificatifs y afférents,
              auprès du Prestataire.
              <br />
              <br />
              Aucune réclamation ne pourra être valablement acceptée en cas de
              non-respect de ces formalités et délais par le Client.
              <br />
              <br />
              Le Prestataire remboursera ou rectifiera dans les plus brefs
              délais et à ses frais les Services dont le défaut de conformité
              aura été dûment prouvé par le Client.
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 6 - DROIT DE RETRACTATION</Heading>
            <p>
              Selon les modalités de l'article L221-28 du Code de ta Consommation, il n’est pas possible d’exercer un droit de rétractation sur les commandes reçues et payées par le client.
              <br/>
              <br/>
              Selon le point N°13 de l'article L221-28 du Code de ta Consommation : 
              <br/>
              <br/>
              Le droit de rétractation ne peut être exercé pour les contrats de fourniture d'un contenu numérique sans support matériel dont l'exécution a commencé avant la fin du délai de rétractation et, si le contrat soumet le consommateur à une obligation de payer, lorsque :
              <br/>
              <ol type="a">
                <li>Il a donné préalablement son consentement exprès pour que l'exécution du contrat commence avant l'expiration du délai de rétractation ; et</li>
                <li>Il a reconnu qu'il perdra son droit de rétractation ; et</li>
                <li>Le professionnel a fourni une confirmation de l'accord du consommateur conformément aux dispositions du deuxième l'alinéa de l'article L. 221-13.</li>
              </ol>
              <br/>
              <br/>
              Le service numérique étant consultable dès l’achat exécuté par le client, il n’est donc pas possible d’exercer un droit de rétractation.
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>
              ARTICLE 7 - RESPONSABILITE DU PRESTATAIRE - GARANTIES
            </Heading>
            <p>
              Le Prestataire garantit, conformément aux dispositions légales et
              sans paiement complémentaire, le Client contre tout défaut de
              conformité ou vice caché, provenant d'un défaut de conception ou
              de réalisation des Services commandés dans les conditions et selon
              les modalités suivantes :
            </p>
            <p>
              <strong>Dispositions relatives aux garanties légales</strong>
            </p>
            <p>
              « Le vendeur est tenu de livrer un bien conforme au contrat et
              répond des défauts de conformité existant lors de la délivrance.
              Il répond également des défauts de conformité résultant de
              l'emballage, des instructions de montage ou de l'installation
              lorsque celle-ci a été mise à sa charge par le contrat ou a été
              réalisée sous sa responsabilité. »
            </p>
            <p>Article L217-5 du Code de la consommation</p>
            <p>« Le bien est conforme au contrat :</p>
            <ul>
              <li>
                S'il est propre à l'usage habituellement attendu d’un bien
                semblable et, le cas échéant :
              </li>
              <li>
                S'il correspond à la description donnée par le vendeur et
                possède les qualités que celui-ci a présentées à l'acheteur sous
                forme d'échantillon ou de modèle.
              </li>
              <li>
                S'il présente les qualités qu'un acheteur peut légitimement
                attendre eu égard aux déclarations publiques faites par le
                vendeur, par le producteur ou par son représentant, notamment
                dans la publicité ou l’étiquetage.
              </li>
              <li>
                Ou s'il présente les caractéristiques définies d'un commun
                accord par les parties ou est propre à tout usage spécial
                recherché par l'acheteur, porté à la connaissance du vendeur et
                que ce dernier a accepté. »
              </li>
            </ul>
            <p>
              <br />
              Article L217-12 du Code de la consommation <br />
              <br />« L'action résultant du défaut de conformité se prescrit par
              deux ans à compter de la délivrance du bien. Afin de faire valoir
              ses droits, le Client devra informer le Prestataire, par écrit
              (mail ou courrier), de l'existence des vices ou défauts de
              conformité. Le Prestataire remboursera ou rectifiera ou fera
              rectifier (dans la mesure du possible) les services jugés :
              Défectueux dans les meilleurs délais et au plus tard dans les 30
              jours suivant la constatation par le Prestataire du défaut ou du
              vice. Ce remboursement pourra être fait par virement ou chèque
              bancaire. La garantie du Prestataire est limitée au remboursement
              des Services effectivement payés par le Client. Le Prestataire ne
              pourra être considéré comme responsable ni défaillant pour tout
              retard ou inexécution consécutif à la survenance d'un cas de force
              majeure habituellement reconnu par la jurisprudence française. Les
              Services fournis par l'intermédiaire du site du Prestataire sont
              conformes à Ia réglementation en vigueur en France. La
              responsabilité du Prestataire ne saurait être engagée en cas de
              non-respect de la législation du pays dans lesquelles les Services
              sont fournis, qu'il appartient au Client, qui est seul responsable
              du choix des Services demandés, de vérifier. »
            </p>
          </section>
          <section>
            <Heading fontSize={"xl"}>ARTICLE 8 - DONNEES PERSONNELLES</Heading>
            <p>
              Le Client est informé que la collecte de ses données à caractère
              personnel est nécessaire à la vente des Services et leur
              réalisation et délivrance, confiées au Prestataire. Ces données à
              caractère personnel sont récoltées uniquement pour l'exécution du
              contrat de prestations de services.
            </p>
            <p>
              <strong>Collecte des données à caractère personnel</strong>
            </p>
            <p>
              Les données à caractère personnel qui sont collectées sur le site
              www.tete-en-lair.fr sont les suivantes :
            </p>
            <p>Commande de Prestations :</p>
            <p>
              Lors de la commande de Prestations par le Client : Noms, prénoms,
              N° de vol, date du vol et adresse e-mail.
            </p>
            <p>
              <strong>Paiement</strong>
            </p>
            <p>
              Dans le cadre du paiement des Prestations proposés sur le site
              www.tete-en-lair.fr, celui-ci enregistre des données financières
              relatives au compte bancaire ou à la carte de crédit du Client /
              utilisateur.
            </p>
            <p>
              <strong>Destinataires des données à caractère personnel</strong>
            </p>
            <p>
              Les données à caractère personnel sont réservées à l'usage unique
              du Prestataire et de ses salariés. Le responsable de traitement
              des données est le Prestataire, au sens de la loi informatique et
              libertés et à compter du 25 mai 2018 du Règlement 2016/679 sur la
              protection des données à caractère personnel.
            </p>
            <p>
              <strong>Limitation du traitement</strong>
            </p>
            <p>
              Sauf si le Client exprime son accord exprès, ses données à
              caractère personnelles ne sont pas utilisées à des fins
              publicitaires ou marketing.
            </p>
            <p>
              <strong>Durée de conservation des données</strong>
            </p>
            <p>
              Le Prestataire conservera les données ainsi recueillies pendant un
              délai de 5ans, couvrant le temps de la prescription de la
              responsabilité civile contractuelle applicable.
            </p>
            <p>
              <strong>Sécurité et confidentialité</strong>
            </p>
            <p>
              Le Prestataire met en œuvre des mesures organisationnelles,
              techniques, logicielles et physiques en matière de sécurité du
              numérique pour protéger les données personnelles contre les
              altérations, destructions et accès non autorisés. Toutefois il est
              à signaler qu'Internet n'est pas un environnement complètement
              sécurisé et le Prestataire ne peut garantir la sécurité de la
              transmission ou du stockage des informations sur Internet.
            </p>
            <p>
              <strong>
                Mise en œuvre des droits des Clients et utilisateurs
              </strong>
            </p>
            <p>
              En application de la règlementation applicable aux données à
              caractère personnel, les Clients et utilisateurs du site
              www.tete-en-lair.fr disposent des droits suivants :
            </p>
            <ul>
              <li>
                Ils peuvent mettre à jour ou supprimer les données qui les
                concernent de la manière suivante : Un contact par mail à
                l'adresse suivante : contact@tete-en-lair.fr avec pour motif la
                suppression de ses données personnelles.
              </li>
              <li>
                Ils peuvent supprimer leur compte en écrivant à l'adresse
                électronique indiqué à l'article 9.3 « Responsable de
                traitement ».
              </li>
              <li>
                Ils peuvent exercer leur droit d'accès pour connaître les
                données personnelles les concernant en écrivant à l'adresse
                indiquée à l'article 9.3 « Responsable de traitement » ;
              </li>
              <li>
                Si les données à caractère personnel détenues par le Prestataire
                sont inexactes, ils peuvent demander la mise à jour des
                informations en écrivant à l'adresse indiqué à l'article 9.3
                « Responsable de traitement ».
              </li>
              <li>
                Ils peuvent demander la suppression de leurs données à caractère
                personnel, conformément aux lois applicables en matière de
                protection des données en écrivant à l'adresse indiqué à
                l'article 9.3 « Responsable de traitement ».
              </li>
              <li>
                Ils peuvent également solliciter la portabilité des données
                détenues par le Prestataire vers un autre prestataire
              </li>
              <li>
                Enfin ils peuvent s'opposer au traitement de leurs données par
                le Prestataire.
              </li>
            </ul>
            <p>
              Ces droits, dès lors qu'ils ne s'opposent pas à la finalité du
              traitement, peuvent être exercé en adressant une demande par
              courrier ou par E-mail au Responsable de traitement dont les
              coordonnées sont indiquées ci­ dessus. <br />
              <br />
              Le responsable de traitement doit apporter une réponse dans un
              délai maximum d'un mois. <br />
              <br />
              En cas de refus de faire droit à la demande du Client, celui-ci
              doit être motivé. <br />
              <br />
              Le Client est informé qu'en cas de refus, il peut introduire une
              réclamation auprès de la CNIL (3 place de Fontenoy, 75007 PARIS)
              ou saisir une autorité judiciaire. <br />
              <br />
              Le Client peut être invité à cocher une case au titre de laquelle
              il accepte de recevoir des mails à caractère informatifs et
              publicitaires de la part du Prestataire. Il aura toujours la
              possibilité de retirer son accord à tout moment en contactant le
              Prestataire (coordonnées ci-dessus) ou en suivant le lien de
              désabonnement.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              ARTICLE 9 - PROPRIETE INTELLECTUELLE
            </Heading>
            <p>
              Le contenu du site www.tete-en-lair.fr est la propriété du Vendeur
              et de ses partenaires et est protégé par les lois françaises et
              internationales relatives à la propriété intellectuelle.
              <br />
              <br /> Toute reproduction totale ou partielle de ce contenu est
              strictement interdite et est susceptible de constituer un délit de
              contrefaçon.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">
              ARTICLE 10 - DROIT APPLICABLE – LANGUE
            </Heading>
            <p>
              Les présentes CGV et les opérations qui en découlent sont régies
              et soumises au droit français. <br />
              Les présentes CGV sont rédigées en langue française. <br />
              Dans le cas où elles seraient traduites en une ou plusieurs
              langues étrangères, seul le texte français ferait foi en cas de
              litige.
            </p>
          </section>
          <section>
            <Heading fontSize="xl">ARTICLE 11 – LITIGES</Heading>
            <p>
              Pour toute réclamation merci de contacter le service clientèle à
              l'adresse postale ou mail du Prestataire indiqué à l’ARTICLE 1 des
              présentes CGV.
              <br />
              <br /> L’Utilisateur est informé de la possibilité qui lui est
              offerte par l’article L.612-1 du Code de la consommation, en cas
              de litige résultant des présentes Conditions Générales, de saisir
              le Médiateur de la consommation : Association Nationale des
              Médiateurs (ANM), lequel peut être contacté par courrier en
              écrivant au 62, rue Tiquetonne 75002 PARIS soit en remplissant le
              formulaire de saisine en ligne à l’adresse suivante :{" "}
              <a href="htttps://www.anm-conso.com" target="_blank">
                www.anm-conso.com
              </a>
              . <br />
              <br />
              Le Client est également informé qu'il peut, également recourir à
              la plateforme de Règlement en Ligne des Litige (RLL) :{" "}
              <a
                href="https://Webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.show"
                target="_blank"
                rel="noopener noreferrer"
              >
                https://Webgate.ec.europa.eu/odr/main/index.cfm?event=main.home.show
              </a>
              . <br />
              <br />
              Tous les litiges auxquels les opérations d'achat et de vente
              conclues en application des présentes CGV et qui n'auraient pas
              fait l'objet d'un règlement amiable entre le vendeur ou par
              médiation, seront soumis aux tribunaux compétents dans les
              conditions de droit commun.
            </p>
          </section>
        </article>
      </Box>
    </Page>
  );
}
